/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import actionInfo from 'cio/utils/action-info';
import { IS_SUBJECT_ACTION_FILTERS, SUBJECT_ACTION_FILTERS as ACTION_FILTERS } from 'cio/utils/action-filters';
import { IS_SUBJECT_EMAIL_FILTERS, SUBJECT_EMAIL_FILTERS as EMAIL_FILTERS } from 'cio/utils/email-filters';
import { isDeliveryMeasureEnabledForChannel } from 'cio/utils/metrics/measure';
import ActionCondition from 'cio/app-models/conditions/action';
import { ActionType } from 'cio/models/action';
import { Channel } from 'cio/utils/metrics/common';
import { sortByCaseInsensitive } from 'cio/utils/sort';

interface Args {
  condition: ActionCondition;
  disabled: boolean;
  size: any;
  fluid: boolean;
  variation: string;
}

export default class EventType extends Component<Args> {
  @computed('args.condition.type')
  get actionInfo() {
    return actionInfo(`${this.args.condition.type}_action` as ActionType, { canConvert: true });
  }

  @computed('args.condition.{type,isForeignEvent}', 'actionInfo.segmentFilters')
  get actionFilters() {
    if (this.args.condition.type === 'email') {
      let filtersToUse = this.args.condition.isForeignEvent ?? false ? IS_SUBJECT_EMAIL_FILTERS : EMAIL_FILTERS;

      return filtersToUse
        .filter(
          // Filter out open if it's disabled on the workspace, unless it's already
          // using it, in which case, we leave it for backwards compat.
          (filter) =>
            !(
              filter.value === 'opened_email' &&
              !isDeliveryMeasureEnabledForChannel('opened', this.args.condition.type as Channel) &&
              this.args.condition.eventType !== 'opened_email'
            ),
        )
        .map((filter) => ({ ...filter, value: filter.value.replace('_email', '_action') }));
    }

    let filters = this.actionInfo.segmentFilters;
    let events = filters?.map((filter) => `${filter}_action`);
    let filtersToUse = this.args.condition.isForeignEvent ?? false ? IS_SUBJECT_ACTION_FILTERS : ACTION_FILTERS;
    let valid = filtersToUse.filter((filter) => events?.includes(filter.value));

    return sortByCaseInsensitive(valid, ['label']);
  }

  @computed('args.{size,fluid}')
  get selectClasses() {
    let classes = ['cio-condition__event-type'];

    if (this.args.size === 'sm') {
      classes = [...classes, 'fly-select--sm'];
    }
    if (this.args.fluid) {
      classes = [...classes, 'fly-select--fluid'];
    }

    return classes.join(' ');
  }
}
